import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Animated } from 'react-native';
import Svg, { Defs, LinearGradient, Rect, Stop } from 'react-native-svg';
import { SkeletonLoaderStrip } from '../../../icons';
import { LILAC_200, LILAC_400 } from '../../../constants';
export var GradientSkeleton = _ref => {
  var translateY = _ref.translateY,
    gradientType = _ref.gradientType;
  var getGradient = () => {
    var translate = translateY.interpolate({
      inputRange: [0, 1],
      outputRange: [-250, 200]
    });
    return _jsx(Animated.View, Object.assign({
      style: {
        opacity: 1,
        transform: [{
          translateX: 0
        }, {
          rotate: '-90deg'
        }, {
          translateX: 50
        }, {
          scale: 2.5
        }, {
          translateY: translate
        }]
      }
    }, {
      children: _jsx(SkeletonLoaderStrip, {
        width: "300%",
        height: "100%",
        gradientType: gradientType
      })
    }));
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(Svg, Object.assign({
      height: "100%",
      width: "100%",
      style: {
        position: 'absolute'
      }
    }, {
      children: [_jsx(Defs, {
        children: _jsxs(LinearGradient, Object.assign({
          id: "grad",
          x1: "0",
          y1: "0",
          x2: "100%",
          y2: "0%"
        }, {
          children: [_jsx(_Fragment, {}), gradientType == 'lilac' ? _jsxs(_Fragment, {
            children: [_jsx(Stop, {
              offset: "0%",
              stopColor: LILAC_400,
              stopOpacity: "0.7"
            }), _jsx(Stop, {
              offset: "23.96%",
              stopColor: LILAC_400,
              stopOpacity: "0.7"
            }), _jsx(Stop, {
              offset: "50%",
              stopColor: LILAC_200,
              stopOpacity: "0.7"
            }), _jsx(Stop, {
              offset: "74.48%",
              stopColor: LILAC_400,
              stopOpacity: "0.7"
            }), _jsx(Stop, {
              offset: "100%",
              stopColor: LILAC_400,
              stopOpacity: "0.7"
            })]
          }) : _jsx(Stop, {
            offset: "0%",
            stopColor: "#CAFDFD",
            stopOpacity: "0.7"
          })]
        }))
      }), _jsx(Rect, {
        x: "0",
        y: "0",
        width: "100%",
        height: "100%",
        fill: "url(#grad)"
      })]
    })), getGradient()]
  });
};